import { Pipe, PipeTransform, Signal, signal } from '@angular/core';
import { TranslationService } from '../services/translation.service';

@Pipe({
    name: 'translation',
    pure: false,
})
export class TranslationPipe implements PipeTransform {
  constructor(private translationService: TranslationService) {}
  private translationSignal!: Signal<string>;

  transform(key: string): string {
    if (this.translationSignal == undefined) {
      this.translationSignal = this.translationService.getTranslationSignal(key);
    }
    return this.translationSignal();
  }
}
